// Recipe labels read "Studio dance · 02b · 10s": the words lead, the rest is the
// maker's reference, shown muted. Splits at the first " · "; a label with none has no rest.
export function splitLabel(label: string): { lead: string; rest: string } {
  const i = label.indexOf(' · ')
  return i < 0 ? { lead: label, rest: '' } : { lead: label.slice(0, i), rest: label.slice(i + 3) }
}

const tokenFormat = new Intl.NumberFormat('en-GB')
export const formatTokens = (n: number) => tokenFormat.format(n)

// Tokens as pounds at a pack's rate: 0 reads "Free", under a pound "under £1".
// `approx: false` drops the "about" where the context already reads as rounded.
export function poundsFor(tokens: number, pack: { tokens: number; price: number }, { approx = true } = {}): string {
  if (tokens <= 0) return 'Free'
  const pounds = (tokens * pack.price) / pack.tokens
  if (pounds < 1) return 'under £1'
  return `${approx ? 'about ' : ''}£${Math.round(pounds)}`
}
